import { render, staticRenderFns } from "./PointCreditTechcoinForm.vue?vue&type=template&id=188883f2"
import script from "./PointCreditTechcoinForm.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports